export default defineNuxtRouteMiddleware(async (to, from) => {
  // console.log('loggedIn middleware', to, from)
  const service = useUserService()
  const user = useUser()
  const session = useVisitorSession()
  if (!user.extra.suspend || session.isAdmin) {
    try {
      await service.getCurrentUserService({ refresh: false })
      // console.log('service data in middleware', service.serviceArray.length)
    } catch (e) {
      console.error(`session ${session.id} get user ${user.id} service info in middleware failed:`, e)
    }
  }
})
